import React, { Component } from "react";
import { ComboBox, Label } from "@fluentui/react";
import { connect } from "react-redux";
import { updateStepValidationStatus } from "../../actions/ValidationActions/clientValidation";
import Warning from "../CreateSite/CommonComponents/Warning";

class RequiredComboBox extends Component {
  state = {
    touched: false,
  };

  componentDidUpdate(prevProps) {
    const nowValid = this.isValid();
    const prevValid = this.isValid(prevProps);
    if (nowValid !== prevValid) {
      this.props.updateStepValidationStatus(this.props.name, nowValid);
    }
  }

  isValid(p = this.props) {
    if (p.multiSelect) {
      return Array.isArray(p.selectedKeys) && p.selectedKeys.length > 0;
    }
    return (
      p.selectedKey !== undefined &&
      p.selectedKey !== null &&
      p.selectedKey !== ""
    );
  }

  render() {
    const showError =
      (this.state.touched || this.props.possibleWarning) && !this.isValid();

    const error = showError
      ? `${this.props.name} cannot be empty`
      : this.props.validationResult &&
        this.props.validationResult.isValid === false
      ? this.props.validationResult.message
      : undefined;

    const warning =
      this.props.possibleWarning &&
      (this.isValid() ||
        (this.props.validationResult &&
          this.props.validationResult.isValid === false)) ? (
        <Warning element="withLabel" />
      ) : null;

    return (
      <div>
        {warning}
        <ComboBox
          placeholder={this.props.placeholder || "Select an option"}
          required
          disabled={this.props.isPickerDisabled}
          {...this.props}
          onBlur={(e) => {
            this.setState({ touched: true });
            if (this.props.onBlur) {
              this.props.onBlur(e);
            }
          }}
          onRenderLabel={(props) => <Label required>{"Required"}</Label>}
          onMenuDismissed={() => this.setState({ touched: true })}
          errorMessage={error}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  possibleWarning: state.wizard.nextStepRequested,
});

const mapActionToProp = {
  updateStepValidationStatus,
};

export default connect(mapStateToProps, mapActionToProp)(RequiredComboBox);



// WEBPACK FOOTER //
// ./src/components/formFields/RequiredComboBox.js